import React, { useState } from 'react';
import { Heart, MessageCircle, Coffee, ExternalLink } from 'lucide-react';
import FeedbackModal from './FeedbackModal';
import ContactModal from './ContactModal';
import PrivacyPolicy from './PrivacyPolicy';

export function Footer() {
  const [showFeedbackModal, setShowFeedbackModal] = useState(false);
  const [showContactModal, setShowContactModal] = useState(false);
  const [showPrivacyPolicy, setShowPrivacyPolicy] = useState(false);

  const handleDonate = () => {
    window.open('https://ko-fi.com/askrumi', '_blank');
  };

  return (
    <footer className="relative z-10 mt-32 border-t border-slate-800/50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="py-12">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 items-center justify-between">
            {/* Left section */}
            <div className="text-center md:text-left">
              <h3 className="text-2xl font-display font-bold bg-gradient-to-r from-blue-400 via-indigo-400 to-purple-400 bg-clip-text text-transparent drop-shadow-[0_0_15px_rgba(59,130,246,0.3)]">
                Ask Rumi
              </h3>
              <p className="mt-2 text-sm bg-gradient-to-r from-blue-400 via-indigo-400 to-purple-400 bg-clip-text text-transparent">
                Your AI Learning Companion
              </p>
            </div>

            {/* Center section - Action buttons */}
            <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
              <button
                onClick={() => setShowFeedbackModal(true)}
                className="group flex items-center space-x-2 px-4 py-2 rounded-lg bg-slate-900/40 backdrop-blur-sm hover:bg-slate-800/40 border border-slate-700/50 hover:border-purple-500/30 transition-all duration-300"
              >
                <Heart className="w-4 h-4 text-purple-400 group-hover:text-purple-300" />
                <span className="text-sm text-slate-300 group-hover:text-slate-200">Feedback</span>
              </button>

              <button
                onClick={handleDonate}
                className="group flex items-center space-x-2 px-6 py-2 rounded-lg bg-gradient-to-r from-blue-600/20 via-indigo-600/20 to-purple-600/20 hover:from-blue-600/30 hover:via-indigo-600/30 hover:to-purple-600/30 border border-indigo-500/30 hover:border-purple-400/50 transition-all duration-300 shadow-lg shadow-indigo-500/10"
              >
                <Coffee className="w-4 h-4 text-indigo-400 group-hover:text-indigo-300" />
                <span className="text-sm text-indigo-300 group-hover:text-indigo-200">Support Us</span>
              </button>

              <button
                onClick={() => setShowContactModal(true)}
                className="group flex items-center space-x-2 px-4 py-2 rounded-lg bg-slate-900/40 backdrop-blur-sm hover:bg-slate-800/40 border border-slate-700/50 hover:border-blue-500/30 transition-all duration-300"
              >
                <MessageCircle className="w-4 h-4 text-blue-400 group-hover:text-blue-300" />
                <span className="text-sm text-slate-300 group-hover:text-slate-200">Contact</span>
              </button>
            </div>

            {/* Right section */}
            <div className="text-center md:text-right">
              <p className="text-sm bg-gradient-to-r from-blue-400 via-indigo-400 to-purple-400 bg-clip-text text-transparent">
                © {new Date().getFullYear()} Ask Rumi
              </p>
              <button
                onClick={() => setShowPrivacyPolicy(true)}
                className="inline-flex items-center mt-2 text-blue-400 hover:text-blue-300 transition-colors"
              >
                Privacy Policy
                <ExternalLink className="ml-1 w-3 h-3" />
              </button>
            </div>
          </div>
        </div>
      </div>

      {showFeedbackModal && (
        <FeedbackModal
          isOpen={showFeedbackModal}
          onClose={() => setShowFeedbackModal(false)}
          onSubmit={(rating, comment) => {
            console.log('Feedback:', { rating, comment });
            setShowFeedbackModal(false);
          }}
          initialRating={5}
        />
      )}

      {showContactModal && (
        <ContactModal
          isOpen={showContactModal}
          onClose={() => setShowContactModal(false)}
        />
      )}

      {showPrivacyPolicy && (
        <PrivacyPolicy
          isOpen={showPrivacyPolicy}
          onClose={() => setShowPrivacyPolicy(false)}
        />
      )}
    </footer>
  );
}